import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Withdraw from Vault',
    chooseAsset: 'Amount',
    balanceText: 'Balance:',
    withdrawalFee: 'Withdrawal fee',
    securityFeeTooltip:
      'Lombard prioritizes security and does not profit from these fees.',
    withdrawalFeeValue: '0.01%',
    withdrawalTime: 'Withdrawal time',
    withdrawalTimeValue: '3 days',
    approveWithdrawal: 'Approve Withdrawal',
    quote:
      'While in the withdrawal queue, you will not earn position yields, loyalty points, Lombard Lux or Veda points. Only one withdrawal may be initiated at a time. If your share value is lower than it was at the time you initiated the request, it will be unable to fulfill due to impermanent loss or market volatility. If this happens, please re-queue your withdrawal at the new rate.',
    statusFetchFailed: 'Faild to fetch withdrawal status',
    exchangeRate: 'Exchange rate',
    youWithdraw: 'You withdraw',
    youReceive: 'You receive',
  },
  
};
